export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Virtuozzo PaaS",
  list: [
    {
      label: "Multi-Language Support",
      text: "Supports Java, PHP, Ruby, Node.js, Go, .NET, Python, and more.",
    },
    {
      label: "Automatic Scaling",
      text: "Adjusts resources based on real-time demand, ensuring performance and cost-efficiency.",
    },
    {
      label: "High Availability",
      text: "Provides clustering and load balancing for critical applications.",
    },
    {
      label: "DevOps Integration",
      text: "Includes CI/CD tools for streamlined development workflows.",
    },
    {
      label: "Marketplace Access",
      text: "Offers a range of pre-configured applications and services for one-click deployment.",
    },
  ],
};
